import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Icono } from "../components/Icono";
import { MODULOS } from "../lib/modulos";

const FOCO = "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secundario focus-visible:ring-offset-2";

export function Sidebar({ abierto, onCerrar }: { abierto: boolean; onCerrar: () => void }) {
  const { usuario, permisos, tenantSlug } = useAuth();
  const [logoFallo, setLogoFallo] = useState(false);
  if (!usuario) return null;

  const modulosVisibles = MODULOS.filter(
    (m) => !m.permisosRequeridos || m.permisosRequeridos.some((p) => permisos.has(p)),
  );

  return (
    <>
      {abierto && (
        <div className="fixed inset-0 z-40 bg-principal/40 lg:hidden" onClick={onCerrar} aria-hidden="true" />
      )}
      <aside
        className={`fixed inset-y-0 left-0 z-50 flex w-full flex-col border-r border-white/10 bg-principal transition-transform duration-200 ease-in-out md:w-72 lg:w-60 lg:translate-x-0 ${
          abierto ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex h-14 items-center justify-between gap-2 border-b border-white/10 px-4">
          <div className="flex items-center gap-2 overflow-hidden">
            {tenantSlug && !logoFallo ? (
              <img
                src={`/api/publico/estudio/${tenantSlug}/logo`}
                alt="Logo del estudio"
                className="h-7 w-7 shrink-0 rounded-md object-contain"
                onError={() => setLogoFallo(true)}
              />
            ) : (
              <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-secundario text-sm font-semibold text-superficie">
                J
              </div>
            )}
            <span className="truncate text-sm font-semibold text-superficie">ERP Jurídico JVD</span>
          </div>
          <button
            type="button"
            onClick={onCerrar}
            aria-label="Cerrar menú"
            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-sidebar-texto transition-colors hover:bg-superficie/10 hover:text-superficie lg:hidden ${FOCO}`}
          >
            <Icono nombre="cerrar" className="h-5 w-5" />
          </button>
        </div>
        <nav className="flex-1 space-y-0.5 overflow-y-auto p-3">
          {modulosVisibles.map((modulo) => (
            <NavLink
              key={modulo.clave}
              to={modulo.ruta}
              className={({ isActive }) =>
                `flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${FOCO} ${
                  isActive
                    ? "bg-secundario text-superficie"
                    : "text-sidebar-texto hover:bg-superficie/10 hover:text-superficie"
                }`
              }
            >
              <Icono nombre={modulo.icono} className="h-5 w-5 shrink-0" />
              {modulo.etiqueta}
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
}
